export const TALK_MOVE_BUCKETS = [
  {
    label: "Share",
    stems: [
      "I think the answer is ___ because...",
      "My strategy for this problem was...",
      "My first step was...",
      "I got stuck when I tried to...",
      "I have a question about...",
    ],
  },
  {
    label: "Invite",
    stems: [
      "What do you think, ___?",
      "How did you get your answer?",
      "Do you agree with that?",
      "___, what do you think we should do?",
    ],
  },
  {
    label: "Build",
    stems: [
      "I see that, but what about this idea...",
      "I want to add to what ___ said...",
      "Can you explain how you got that?",
      "That's like what ___ said, except...",
    ],
  },
];

// FNV-1a: a stable hash, so every student's browser draws the same stems
// without the server sending them or anything being stored. The final mix
// spreads the high bits into the low ones; without it, `% 4` only sees the
// low bits of each character and the draw repeats every four questions.
const hash = (str) => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  h ^= h >>> 16;
  h = Math.imul(h, 0x85ebca6b);
  h ^= h >>> 13;
  h = Math.imul(h, 0xc2b2ae35);
  h ^= h >>> 16;
  return h >>> 0;
};

export const drawTalkMoves = (sessionId, questionNumber) =>
  TALK_MOVE_BUCKETS.map(({ label, stems }) => ({
    label,
    text: stems[hash(`${sessionId}:${questionNumber}:${label}`) % stems.length],
  }));
